// extracted by mini-css-extract-plugin
module.exports = {"header":"ReferencesLinks_header__cXVyl","link":"ReferencesLinks_link__lKIOA"};